import styled from 'styled-components';

const CapacitySectionStyled = styled.div``;

export { CapacitySectionStyled };
